import React from 'react';
import PropTypes from 'prop-types';
import PersonalIdentificationType from '../../../model/PersonalIdentificationType';
import Tooltip from '../../Tooltip/Tooltip';
import NZ_DRIVER_LICENSE_HINT from '../../../assets/NZ_DRIVER_LICENSE_HINT.png';
import NZ_PASSPORT_HINT from '../../../assets/NZ_PASSPORT_HINT.png';
import NZ_DRIVER_LICENSE_BACK_HINT from '../../../assets/NZ_DRIVER_LICENSE_BACK_HINT.png';
import './IdentificationHints.scss';

const getAnchorText = type =>
  type === PersonalIdentificationType.NZ_DRIVER_LICENSE ?
    'Where to find your Drivers License details' : 'Where to find your Passport details';

const getTitle = type => getAnchorText(type);

const getHintImages = type =>
  type === PersonalIdentificationType.NZ_DRIVER_LICENSE ?
    (<div>
      <div className="img-div">
        <img src={NZ_DRIVER_LICENSE_HINT} alt="Where to find your information" />
      </div>
      <div className="img-div">
        <img src={NZ_DRIVER_LICENSE_BACK_HINT} alt="Where to find your information" />
      </div>
    </div>)
    :
    (<div className="img-div">
      <img src={NZ_PASSPORT_HINT} alt="Where to find your information" />
    </div>)
;

const IdentificationHint = props =>
  <Tooltip title={getAnchorText(props.personalIdentificationType)} hasIcon>
    <div className="advice-section identification-hints">
      <h4>{getTitle(props.personalIdentificationType)}</h4>
      <p>Information required in the credit assessment is highlighted below in orange</p>
      {getHintImages(props.personalIdentificationType)}
    </div>
  </Tooltip>;

IdentificationHint.propTypes = {
  personalIdentificationType: PropTypes.string
};

export default IdentificationHint;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/PersonalIdentification/IdentificationHint.js
 **/